var exports = {
  "h_": "GiftSendToFriendModal.module__description___bkJ4Tl",
  "jo": "GiftSendToFriendModal.module__sendButton___bkJ4Tl",
  "Zw": "GiftSendToFriendModal.module__giftCodeText___bkJ4Tl",
  "A4": "GiftSendToFriendModal.module__giftCode___bkJ4Tl",
};

module.exports = exports;
